import React from 'react';
import { AlertBanner, AlertBannerTypes } from '../../Components/AlertBanner';
import styles from './FreeTextMedicationWarningBar.module.css';
export function FreeTextMedicationWarningBar() {
    var prompt = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.regular }, "This medication history item uses a free-text name. If you choose to re-prescribe this you will have to select a codified medication.")));
    return React.createElement(AlertBanner, { promptMessage: prompt, promptType: AlertBannerTypes.Warn, verticalSpace: true });
}
